<template>
  <div style="padding: 0 10px">
    <div style="text-align: left">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        @keydown.native.enter="submit"
      >
        <el-form-item label="批次">
          <el-input
            maxlength="50"
            placeholder="请输入"
            v-model="formInline.pkgCode"
            clearable
            @clear="getList"
          ></el-input>
        </el-form-item>
        <el-form-item label="操作时间">
        <el-date-picker v-model="formInline.date" type="datetimerange"
          :default-time="['00:00:00', '23:59:59']" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
        </el-form-item>
        <el-form-item label="业务单据">
          <el-input
            maxlength="50"
            placeholder="请输入"
            v-model="formInline.bizOrderNo"
            clearable
            @clear="getList"
          ></el-input>
        </el-form-item>
        <el-form-item label="系统单据">
          <el-input
            maxlength="50"
            placeholder="请输入"
            v-model="formInline.systemOrderNo"
            clearable
            @clear="getList"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button style="" type="primary" @click="submit">查询</el-button>
          <el-button style="margin-left: 10px" @click="rest">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <WmsTable
      :columns="columns"
      :dataSource="dataSource"
      @pageChange="pageChangeCall"
      :hasHeader="false"
      :isPagination="query"
    >
    </WmsTable>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import { columns } from "./data";
import {
  stockHistory
} from "@/apis/inventoryDetails";
export default {
  title: "容器列表",
  name: "container",
  components: { WmsTable },
  props: {},
  data() {
    return {
      formInline: {},
      columns,
      dataSource: [],
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      }
    };
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    submit() {
      this.query.current = 1;
      this.getList();
    },
    rest() {
      this.date = null;
      Object.keys(this.formInline).forEach((i) => {
        this.formInline[i] = undefined;
      });
      this.query = {
        current: 1,
        pageSize: 10,
        total: 0,
      };
      this.getList();
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getList();
    },
    getList() {
      const params = {
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        ...this.formInline
      }
      if(params.date){
        params.startTime = params.date[0]
        params.endTime = params.date[1]
      }
      params.date && delete params.date
      stockHistory(params).then((res) => {
        this.dataSource = res.data.records
        this.query.total = res.data.total
      });
    }
  },
};
</script>

<style scoped lang="less">
.action {
  span {
    cursor: pointer;
  }
  .active {
    color: #409eff;
  }
  .disabled {
    color: #c7c7c7;
    cursor: not-allowed;
  }
}

.productAmount {
  .btn {
    color: #409eff;
    cursor: pointer;
  }
}
</style>
